import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import styles from './styles.module.scss';
import Heading from '../../shared/heading';
import Link from '../../shared/link';

const MOTION_EASE = [0.25, 0.1, 0.25, 1];

const wrapperVariants = {
  appear: {
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.4,
    },
  },
};
const itemsVariants = {
  initial: {
    opacity: 0,
  },
  appear: {
    opacity: 1,
    transition: {
      duration: 0.7,
      ease: MOTION_EASE,
    },
  },
};

const Features = ({ title = null, items = [], theme = 'dark' }) => {
  const [imageUrls, setImageUrls] = useState({});
  const [sectionRef, inView] = useInView({ threshold: 0.4, triggerOnce: true });
  const headingColor = {
    dark: 'tertiary',
    light: 'primary',
  };

  useEffect(() => {
    const imagesMap = items?.reduce((acc, item) => {
      const source = document
        .getElementById(`img-${item.image.id}`)
        ?.querySelector('img[data-main-image]');
      const urls = (source?.dataset?.srcset || source?.srcset)?.split(',');
      return {
        ...acc,
        [item.image.id]: {
          thumbnail: urls?.[0]?.split(' ')?.[0]?.trim(),
          original: urls?.[urls.length - 1]?.split(' ')?.[0]?.trim(),
        },
      };
    }, {});
    // console.log('images', imagesMap);
    setImageUrls(imagesMap);
  }, [items]);

  return (
    <section ref={sectionRef} className={cn(styles.features, styles[theme])}>
      <div className={styles.featuresInnerWrapper}>
        <div className={cn('container', styles.inner)}>
          {title && (
            <Heading className={styles.title} color={headingColor[theme]} tag="h2" size="xl">
              {title}
            </Heading>
          )}
          <motion.div
            className={styles.itemsWrapper}
            animate={inView ? 'appear' : 'initial'}
            variants={wrapperVariants}
          >
            <div className={styles.itemsInner}>
              {items.map(({ title, link, image }, index) => (
                <Link className={styles.item} to={link || ''} key={index}>
                  <div className={styles.itemImageWrapper}>
                    <motion.div variants={itemsVariants}>
                      <img
                        className={styles.itemImage}
                        src={imageUrls[image.id]?.original}
                        alt=""
                      />
                    </motion.div>
                  </div>
                  <Heading className={styles.itemTitle} tag="h3" size="lg" innerHTML={title} />
                </Link>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Features;


Features.propTypes = {
  title: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      link: PropTypes.string,
    })
  ),
};
